/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { toggleDividendsReinvestPostRequestSchema } from './toggleDividendsReinvestPostRequestSchema.ts';
import { toggleDividendsReinvestPostResponseSchema } from './toggleDividendsReinvestPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postToggleDividendsReinvest200Schema = z.lazy(() => toggleDividendsReinvestPostResponseSchema);

/**
 * @description 505 response
 */
export const postToggleDividendsReinvest505Schema = z.any();

export const postToggleDividendsReinvestMutationRequestSchema = z.lazy(() => toggleDividendsReinvestPostRequestSchema);

export const postToggleDividendsReinvestMutationResponseSchema = z.lazy(() => postToggleDividendsReinvest200Schema);
